'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Container } from '@src/components/Container/Container';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavMobileBar = () => {
  const $ = _c(22);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    isMobileSubExpanded,
    logo,
    signUpCta,
    isExpanded,
    setExpanded,
    setExpandedMenu,
    setMobileSubExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== isExpanded || $[1] !== isMobileSubExpanded || $[2] !== setExpanded || $[3] !== setExpandedMenu || $[4] !== setMobileSubExpanded) {
    t0 = () => <button data-testid="topNavMobileMenu" onClick={() => {
      if (!isExpanded || !isMobileSubExpanded) {
        setExpandedMenu(null);
        setMobileSubExpanded(false);
      }
      setExpanded(!isExpanded);
    }} className={"flex size-6 appearance-none flex-col items-center justify-center\n          *:h-0.5 *:w-6 *:rounded-sm *:bg-white *:transition-all"}><div className={cn("-translate-y-1", {
        "rotate-45 translate-y-0.5": isExpanded
      })} /><div className={cn({
        "opacity-0": isExpanded
      })} /><div className={cn("translate-y-1", {
        "-rotate-45 -translate-y-0.5": isExpanded
      })} /></button>;
    $[0] = isExpanded;
    $[1] = isMobileSubExpanded;
    $[2] = setExpanded;
    $[3] = setExpandedMenu;
    $[4] = setMobileSubExpanded;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const renderHamburger = t0;
  let t1;
  if ($[6] !== renderHamburger) {
    t1 = <div className="flex items-center">{renderHamburger()}</div>;
    $[6] = renderHamburger;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== logo || $[9] !== trackSelectNavCta) {
    t2 = logo?.src && <LocalizedLink onClick={() => {
      trackSelectNavCta({
        "cta url": logo?.href
      });
    }} href={logo?.href ?? ""}><Image src={logo.src} width={logo?.mobileWidth} height={logo?.mobileHeight} alt={logo?.altText ?? ""} /></LocalizedLink>;
    $[8] = logo;
    $[9] = trackSelectNavCta;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = <div className="flex gap-6">{t1}{t2}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== signUpCta || $[15] !== trackSelectNavCta) {
    t4 = signUpCta && <LocalizedLink data-testid="signUpBtn" onClick={() => {
      trackSelectNavCta({
        "cta url": signUpCta?.href
      });
    }} href={signUpCta?.href ?? ""} rel={signUpCta?.newTab ? "noopener noreferrer" : ""} target={signUpCta?.newTab ? "_blank" : "_self"} className="block"><p className="text-body-md">{signUpCta?.title}</p></LocalizedLink>;
    $[14] = signUpCta;
    $[15] = trackSelectNavCta;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <div className="flex gap-6">{t4}</div>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t5) {
    t6 = <Container className="h-full *:h-full"><div className="flex h-full flex-row items-center justify-between">{t3}{t5}</div></Container>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};